function injectStyle (ssrContext) {
  require("!!../../../../node_modules/.store/extract-text-webpack-plugin@2.0.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0f29d35f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=styles&index=0!./kxSelect.vue")
}
var Component = require("!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=script&index=0!./kxSelect.vue"),
  /* template */
  require("!!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0f29d35f\"}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=template&index=0!./kxSelect.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f29d35f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/kxSelect/kxSelect.vue
// module id = 946
// module chunks = 76